import { DAY_S, J2000, dateToJd } from "./time";

export interface SpeedPreset {
  label: string;
  secondsPerSecond: number;
}

const YEAR_S = 365.25 * DAY_S;
export const SPEED_PRESETS: SpeedPreset[] = [
  { label: "real time", secondsPerSecond: 1 },
  { label: "1 minute / s", secondsPerSecond: 60 },
  { label: "1 hour / s", secondsPerSecond: 3600 },
  { label: "1 day / s", secondsPerSecond: DAY_S },
  { label: "1 month / s", secondsPerSecond: YEAR_S / 12 },
  { label: "1 year / s", secondsPerSecond: YEAR_S },
  { label: "10 years / s", secondsPerSecond: 10 * YEAR_S },
];

/** Longest real-time step applied per tick; a backgrounded tab resumes without a jump. */
export const MAX_REAL_DELTA_S = 0.1;

/** Supported simulation window: J2000 +/- 3000 Julian years. */
const JD_WINDOW_DAYS = 1095750;
export const JD_MIN = J2000 - JD_WINDOW_DAYS;
export const JD_MAX = J2000 + JD_WINDOW_DAYS;

export function clampJd(jd: number): number {
  return Math.min(Math.max(jd, JD_MIN), JD_MAX);
}

export class Clock {
  jd: number;
  speed = 60; // one simulated minute per real second
  paused = false;

  constructor(jd = dateToJd(new Date())) {
    this.jd = jd;
  }

  tick(realDeltaSeconds: number): void {
    if (this.paused) return;
    const dt = Math.min(Math.max(realDeltaSeconds, 0), MAX_REAL_DELTA_S);
    this.jd = clampJd(this.jd + (dt * this.speed) / DAY_S);
  }

  setNow(): void {
    this.jd = clampJd(dateToJd(new Date()));
  }
}
